const apiAddress = 'https://api.banarecords.com';

const constants = {
  apiUrl: `${apiAddress}/api`,
  mediaUrl: `${apiAddress}/media`,
  authUrl: 'auth-bana29',
  keys: {
    user: 'user',
  },
  prefixes: {
    sorting: 'sorting',
    visibility: 'visibility',
    density: 'density',
    rowsPerPage: 'rows_per_page',
  },
};

export default constants;
